/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refusal_Sign_InInputs */



/**
* | output |
* | --- |
* | "Sign in again" |
*
* @param {Refusal_Sign_InInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const refusal_sign_in = /** @type {((inputs?: Refusal_Sign_InInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refusal_Sign_InInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Войти снова")
	return /** @type {LocalizedString} */ ("Sign in again")
});